export default __webpack_public_path__ + "static/media/circle.c985c9f7.svg";